import * as types from "./mutation-types";

export const saveDashboardData = ({ commit }, dashboardData) => {
  commit(types.SAVE_DASHBOARD_DATA, dashboardData);
};
export const saveStudyId = ({ commit }, studyId) => {
  commit(types.SAVE_STUDY_ID, studyId);
};
export const saveSitesData = ({ commit }, sitesData) => {
  commit(types.SAVE_SITES_DATA, sitesData);
};
export const saveBenchMarkData = ({ commit }, benchMarkData) => {
  commit(types.SAVE_BENCHMARK_DATA, benchMarkData);
};
export const saveEnrollmentData = ({ commit }, enrollmentData) => {
  commit(types.SAVE_ENROLLMENT_DATA, enrollmentData);
};
export const saveEconsentUploadedData = ({ commit }, eConsentUploadedData) => {
  commit(types.SAVE_ECONSENT_UPLOADED_DATA, eConsentUploadedData);
};
export const saveTopScreenFailuareReasons = ({ commit }, topScreenFailuaresReason) => {
  commit(types.SAVE_TOP_SCREEN_FAIL_REASONS, topScreenFailuaresReason);
};
export const saveQuizData = ({ commit }, quizData) => {
  commit(types.SAVE_QUIZ_DATA, quizData);
};
export const saveRecruitementData = ({ commit }, recruitmentData) => {
  commit(types.SAVE_RECRUITEMENT_DATA, recruitmentData);
};
export const saveSensorComplianceData = ({ commit }, sensorComplianceData) => {
  commit(types.SAVE_SENSOR_COMPLIANCE_DATA, sensorComplianceData);
};
export const saveOverallCollectionData = ({ commit }, overallCollectionData) => {
  commit(types.SAVE_OVERALL_COLLECTION_DATA, overallCollectionData);
};
export const saveCancelledThVisitData = ({ commit }, cacelledTelehealthVisits) => {
  commit(types.SAVE_CANCELLED_TH_VISIT_DATA, cacelledTelehealthVisits);
};
export const saveComplianceInsightScore = ({ commit }, complianceInsightScore) => {
  commit(types.SAVE_COMPLIANCE_INSIGHT_SCORE, complianceInsightScore);
};
export const saveOverallCollectionMissingData = ({ commit }, overallCollectionMissingData) => {
  commit(types.SAVE_OVERALL_COLLECTION_MISSING_DATA, overallCollectionMissingData);
};
export const saveNonCompliantActivities = ({ commit }, nonCompliantActivities) => {
  commit(types.SAVE_NON_COMPLIENT_ACTIVITIES, nonCompliantActivities);
};
export const saveTelehealthVisitsDuration = ({ commit }, telehealthVisitsDuration) => {
  commit(types.SAVE_TH_VISITS_DURATION, telehealthVisitsDuration);
};
export const saveComplianceRateOverTime = ({ commit }, complianceRateOverTime) => {
  commit(types.SAVE_COMPLIANCE_RATE_OVER_TIME, complianceRateOverTime);
};
export const saveStudyComplianceData = ({ commit }, studyComplianceData) => {
  commit(types.SAVE_STUDY_COMPLIANCE_DATA, studyComplianceData);
};
export const saveStudyParticipantComplianceData = ({ commit }, studyParticipantComplianceData) => {
  commit(types.SAVE_STUDY_PARTICIPANT_COMPLIANCE_DATA, studyParticipantComplianceData);
};
export const saveOverallCollectionParticipantData = ({ commit }, overallCollectionParticipantData) => {
  commit(types.SAVE_OVERALL_COLLECTION_PARTICIPANT_DATA, overallCollectionParticipantData);
};
export const saveGraphicComplianceData = ({ commit }, graphicComplianceData) => {
  commit(types.SAVE_GRAPHIC_COMPLIANCE_DATA, graphicComplianceData);
};
export const saveAnalyticsUserData = ({ commit }, analyticsUsersData) => {
  commit(types.SAVE_ANALYTICS_USER_DATA, analyticsUsersData);
};
export const saveDashboardRefreshData = ({ commit }, dashboardRefreshData) => {
  commit(types.SAVE_DASHBOARD_REFRESH_DATA, dashboardRefreshData);
};
export const saveSiteByIdData = ({ commit }, siteById) => {
  commit(types.SAVE_SITE_BY_ID_DATA, siteById);
};
export const saveAllEnrollmentData = ({ commit }, allEnrollmentData) => {
  commit(types.SAVE_ALL_ENROLLMENT_DATA, allEnrollmentData);
};
export const saveParticipantProgressData = ({ commit }, participantProgressData) => {
  commit(types.SAVE_PARTICIPANT_PROGRESS_DATA, participantProgressData);
};
export const saveDiscontinuationActivity = ({ commit }, discontinuationActivity) => {
  commit(types.SAVE_DISCONTINUATION_ACTIVITY, discontinuationActivity);
};
export const saveOtherDiscontinuationReasons = ({ commit }, otherDiscontinuationReasons) => {
  commit(types.SAVE_OTHER_DISCONTINUATION_REASONS, otherDiscontinuationReasons);
};
export const saveParticipantStudyProgression = ({ commit }, participantStudyProgression) => {
  commit(types.SAVE_PARTICIPANT_STUDY_PROGRESSION, participantStudyProgression);
};
export const saveMiletonesData = ({ commit }, milestonesData) => {
  commit(types.SAVE_MILESTONES_DATA, milestonesData);
};
export const saveQueriesData = ({ commit }, queriesData) => {
  commit(types.SAVE_QUERIES_DATA, queriesData);
};
export const saveQueriesTimeData = ({ commit }, queriesTimeList) => {
  commit(types.SAVE_QUERIES_TIME_DATA, queriesTimeList);
};
export const saveActivitiesData = ({ commit }, activitiesData) => {
  commit(types.SAVE_ACTIVITIES_DATA, activitiesData);
};
export const saveFormStatusData = ({ commit }, formStatusData) => {
  commit(types.SAVE_FORM_STATUS_DATA, formStatusData);
};
export const saveTotalQueryData = ({ commit }, totalQueryData) => {
  commit(types.SAVE_TOTAL_QUERY_DATA, totalQueryData);
};
export const saveTotalDataChangeData = ({ commit }, totalDataChangeData) => {
  commit(types.SAVE_TOTAL_DATA_CHANGE, totalDataChangeData);
};